import { unfold, fromPairs } from 'ramda';
export const formatMarks = function () {
  let min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  let step = arguments.length > 2 ? arguments[2] : undefined;
  const f = seed => {
    if (seed === min) {
      return [min, parseInt(min / step) * step + step];
    } else if (seed >= max) {
      return false;
    } else if (seed > max - step / 3) {
      // 倒数第二个点小于1/3的不展示
      return false;
    } else {
      return [seed, seed + step];
    }
  };
  const markArr = [...unfold(f, min), max];
  return fromPairs(markArr.map(item => [item, item]));
};
const formatInt = function (num) {
  let prec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let ceil = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const len = String(num).length;
  if (len <= prec) {
    return num;
  }
  const mult = Math.pow(10, prec);
  return ceil ? Math.ceil(num / mult) * mult : Math.floor(num / mult) * mult;
};
export const formatMarksForCount = function () {
  let min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  let count = arguments.length > 2 ? arguments[2] : undefined;
  const difference = max - min;
  const step = formatInt(difference / count, parseInt(difference / count).toString().length - 1);
  return formatMarks(min, max, step);
};